// extracted by mini-css-extract-plugin
export default {"closeIcon":"CloseIcon_closeIcon__QgI3x","lines":"CloseIcon_lines__insX8","white":"CloseIcon_white__3N80+"};